import React from 'react';
import MediaContext from './MediaContext';

/**
 * connectToPlayer
 * @param Component
 * @returns Wrapped Component
 */

function connectToMedia(
  mapStateToProps = (state) => state,
) {
  return (WrappedComponent) => {
    // ...and returns another component...
    class Injector extends React.Component {
      static contextType = MediaContext;

      constructor(...args) {
        super(...args);
      }

      state = {};

      subscription = null;

      componentDidMount() {
        const { $: store$ } = this.context;

        this.subscription = store$.subscribe((nextState) => {
          const mappedProps = mapStateToProps(nextState);
          const hasUpdates = Object
            .keys(mappedProps)
            .some((prop) => (mappedProps[prop] !== this.state[prop]));

          if (hasUpdates) {
            this.setState((prevState) => ({ ...prevState, ...mappedProps }));
          }
        });
      }

      componentWillUnmount() {
        this.subscription.unsubscribe();
      }

      render() {
        const { actions } = this.context;
        return (
          <WrappedComponent
            {...this.state}
            onPlay={actions.playMedia}
            onPause={actions.pauseMedia}
            onSeek={actions.seekMedia}
            onSkipPrevNextHit={actions.skipPrevNextHit}
            onVolume={actions.setVolumeMedia}
            onSearch={actions.addQuery}
            onAddQuery={actions.addQuery}
            onRemoveQuery={actions.removeQuery}
            onChangeSentimentAnalyzer={actions.setSentimentAnalyzer}
            onChangeKeywordAnalyzer={actions.setKeywordAnalyzer}
            onChangePhraseSupportingAnalyzer={actions.setPhraseSupportingAnalyzer}
            onChangeVerbNounAnalyzer={actions.setVerbNounAnalyzer}
            onChangeEntitiesAnalyzer={actions.setEntitiesAnalyzer}
            onPlaybackSpeedChange={actions.setPlaybackSpeed}
            {...this.props}
          />
        );
      }
    }

    return Injector;
  };
}

export default connectToMedia;
